export default __webpack_public_path__ + "static/media/Ballroll_00053.021e7e7b.png";